import React from "react";
import { unitLabel } from "../lib/customerUnit";

/** The flat (or first address line) under a customer's name on admin screens.
 *  `requireFlat` = the store requires a flat number: then an address without
 *  one is flagged, so it can be completed on the next edit. */
export default function CustomerUnit({ address, requireFlat, testId, className = "" }) {
  const { text, missing } = unitLabel(address);
  if (!text && !(missing && requireFlat)) return null;
  return (
    <div className={`text-xs text-neutral-600 flex flex-wrap items-center gap-x-1.5 gap-y-0.5 min-w-0 ${className}`} data-testid={testId}>
      {text && <span className="truncate max-w-full font-semibold" title={text}>{text}</span>}
      {missing && requireFlat && (
        <span className="shrink-0 px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800 text-[10px] font-extrabold uppercase tracking-wider"
              data-testid={testId ? `${testId}-missing` : undefined}>No flat number</span>
      )}
    </div>
  );
}
